import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserPreferences } from '@ddv/models';
import { InitializationErrorCollectorService } from '@ddv/navigation';
import { Fund, FundAvailability, FundsService } from '@hs/ui-core-fund';
import { catchError, Observable, of } from 'rxjs';

// because we need the user-preferences in order to load the funds
// this resolver should always be attached on a child route no the main route
export const fundsResolver: ResolveFn<Fund[]> = (route): Observable<Fund[]> => {
    const errorCollector = inject(InitializationErrorCollectorService);
    const service = inject(FundsService);

    const clientCode = route.paramMap.get('clientCode') ?? '';
    const nameSource = (route.data.preferences as UserPreferences).fundNamesSource as FundAvailability.HSMain | FundAvailability.HI;
    return service.loadEntitledFunds(clientCode, nameSource)
        .pipe(catchError((error) => {
            errorCollector.addError(`Failed to load funds with name-source ${nameSource} for client ${clientCode}`, error);
            return of([]);
        }));
};
